import { darkTheme as iDarkTheme, theme as iLightTheme, ThemeProvider } from '@intelie/ui'
import React, { useContext } from 'react'
import { useTheme } from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'
import liveTheme from 'live/services/theme'

import { EnvProperties } from './EnvProperties'

const lightTheme = { ...iLightTheme, ...liveTheme }
const darkTheme = { ...iDarkTheme, ...liveTheme }

export const EnvPropertiesWrapper: React.FC<{ urlParams: string[] }> = () => {
    const theme = useTheme()
    const dashTheme = useContext(DashboardContext).theme

    if (theme?.['gray-100']) {
        return <EnvProperties />
    } else {
        return (
            <ThemeProvider themeMerger={theme => theme} theme={dashTheme === 'light' ? lightTheme : darkTheme}>
                <EnvProperties />
            </ThemeProvider>
        )
    }
}
